module.exports = __webpack_public_path__ + "img/title.b1b39dba.12e0f54f.png";